var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { Button, Radio } from "@savvyinsure/react-ui";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import { PHASE } from "../../../routeConfig";
import { PivotReason } from "../../../features/applicant/applicantSlice";
import { completedPage } from "../../../lib/Avo";
import { savePolicyHolder } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import useAppSelector from "../../../hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import useMemoryHistory from "../../../hooks/useMemoryHistory";
function parseIsMilitary(isMilitary) {
    if (typeof isMilitary === "boolean") {
        return isMilitary ? "true" : "false";
    }
    return isMilitary;
}
export default function UnlinkedApplicationAutoMilitaryPage() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var isMilitary = useAppSelector(function (state) { return state.unlinkedApplication.policyHolder.isMilitary; });
    var _a = useForm({
        defaultValues: {
            isMilitary: parseIsMilitary(isMilitary),
        },
    }), register = _a.register, handleSubmit = _a.handleSubmit, errors = _a.formState.errors;
    var push = useMemoryHistory().push;
    var dispatch = useDispatch();
    var buttonRef = React.useRef(null);
    var isBundleAutoFromHome = useAppSelector(function (state) {
        return state.applicant.bundlePivotReason === PivotReason.BundleAutoFromHome;
    });
    var militaryInput = register("isMilitary", {
        required: true,
        onChange: function () {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.click();
        },
    });
    function getNextRoute() {
        if (isBundleAutoFromHome) {
            return PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER;
        }
        return PHASE.UNLINKED_APPLICATION_AUTO_REVIEW;
    }
    var nextRoute = getNextRoute();
    var onSubmit = handleSubmit(function (data) {
        var selectedOption = data.isMilitary;
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
        dispatch(savePolicyHolder({ isMilitary: selectedOption === "true" }));
        push(nextRoute);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { as: "form", onSubmit: onSubmit },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement(UnlinkedApplicationForm.Header, { className: "mb-6 pt-4" }, "Have you or your spouse honorably served in the U.S. Military?"),
                React.createElement("div", { className: "mb-6 space-y-2" },
                    React.createElement(Radio, __assign({ value: "true", label: "Yes", variant: "contained" }, militaryInput)),
                    React.createElement(Radio, __assign({ value: "false", label: "No", variant: "contained" }, militaryInput))),
                React.createElement(Button, { ref: buttonRef }, "Continue"),
                errors.isMilitary ? (React.createElement("p", { className: "mt-2 text-red" }, "Please select an option")) : null))));
}
